import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import ResourceModal from 'app/components/ResourceModal';
import ResourceModalPanel from 'app/components/ResourceModalPanel';
import UploadModal from 'app/components/Uploads/UploadModal';
import useMomentsUploadForm from 'app/hooks/useMomentsUploadForm';
import useDeeplink from 'app/hooks/useDeeplink';
import AccountForm from './AccountForm';
import FeatureFlagsForm from './FeatureFlagsForm';
import AccountUserForm from './AccountUserForm';

import {
  AND_OPERATOR,
} from 'app/hooks/useFilter';

import {
  switchAccount
} from 'app/actions/portalActions';

import {
  home as homePath
} from 'app/routes';

const AccountPanel = props => {
  const {
    account,
    action,
    onDelete,
    onUploadStart,
    onClose,
    updateRow,
    setLastUpdate
  } = props;

  const [showFeatureFlags, setShowFeatureFlags] = useState(false);
  const openFeatureFlags = () => setShowFeatureFlags(true);
  const closeFeatureFlags = () => setShowFeatureFlags(false);

  const [showAccountUsers, setShowAccountUsers] = useState(false);
  const openAccountUsers = () => setShowAccountUsers(true);
  const closeAccountUsers = () => setShowAccountUsers(false);

  const {
    formIsOpen,
    onFormOpen,
    onFormClose,
    onFormSubmit
  } = useMomentsUploadForm({
    onUploadStart,
    account
  });

  const dispatch = useDispatch();
  const history = useHistory();
  const deeplink = useDeeplink();

  // if we're creating a job then no actions panel will be shown
  if (action === 'create') {
    return null;
  }

  const enterAccount = async () => {
    await dispatch(switchAccount(account.id));
    history.push(homePath);
    onClose();
  }

  let cards = [
    {
      label: 'Enter Account',
      message: 'Login to this account',
      actions: [
        { label: 'Enter Account', callback: enterAccount }
      ]
    },
    {
      label: 'Logo',
      images: [{
        src: account.logo_url,
        w: 400,
        h: 400
      }],
      imageCount: 1,
      details: [
      ],
      actions: [
        { label: 'Upload New', callback: onFormOpen }
      ]
    },
    {
      label: 'Account Users',
      message: 'Manage account users',
      actions: [
        { label: 'Edit Account Users', callback: openAccountUsers }
      ]
    },
    {
      label: 'Feature Flags',
      message: 'Manage account features',
      actions: [
        { label: 'Edit Feature Flags', callback: openFeatureFlags }
      ]
    },
    {
      label: 'Delete Account',
      message: 'Delete the account',
      actions: [
        { label: 'Delete Account', callback: onDelete }
      ]
    }
  ]

  return (
    <div>
      <ResourceModalPanel cards={cards} />
      <UploadModal
        isOpen={formIsOpen}
        onClose={onFormClose}
        onFormSubmit={onFormSubmit}
      />
      <FeatureFlagsForm
        isOpen={showFeatureFlags}
        onClose={closeFeatureFlags}
        account={account}
        updateRow={updateRow}
        setLastUpdate={setLastUpdate}
      />
      <AccountUserForm
        isOpen={showAccountUsers}
        onClose={closeAccountUsers}
        account={account}
      />
    </div>
  );
}

const AccountModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    onDestroy,
    onUploadStart,
    account,
    updateRow
  } = props;

  // enable feature flags form to update the account form's accountType
  const [lastUpdate, setLastUpdate] = useState(Date.now());

  const action = account ? 'update' : 'create';

  let title, subTitle = null;
  if (action === 'update') {
    title = account.name;
    subTitle = account.id;
  } else {
    title = 'New Account';
  }

  const onSubmit = params => onFormSubmit(action, params)
  const onDelete = () => onDestroy(account.id);

  return (
    <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
      <AccountPanel {...{ account, action, onClose, onDelete, onUploadStart, updateRow, setLastUpdate }} />
      <AccountForm {...{ account, action, onClose, onSubmit, lastUpdate }} />
    </ResourceModal>
  );
}

export default AccountModal;
